import React,{useState, useEffect, Suspense} from "react"
import { StoreSearchView } from "src/components/Views/storeSearchView"
import { NextPrevParts } from "../Parts/nextPrevParts"
import { Loader } from "src/components/Parts/loaderParts";
import { Useable } from 'src/utils/Useable';
import { fetchAreas } from 'src/data/fetch'
import {fetchStores } from 'src/data/fetch'
import { StoreSelectView } from "../Views/storeSelectView";
import { FlowParts } from "../Parts/flowParts";



export const StoreSearchPage = (props) => {

    window.scrollTo(0,0)
    
    const [query, setQuery] = useState()
    const [ stores, setStores ] = useState(0)
    const [ defaultValue, setDefaultValue ] = useState(
        {
            area: {id:0, name:'エリア\n選択'},
            city : {id:0, name:'市区町村\nを選択'},
            keyword : null,
            store : null
        }
    )
    
    useEffect(() => {
        if(props.defaultValue.store){
            const defaultStore = props.defaultValue.store
            let query = '';
            defaultStore.areas_id > 0 ? query += `area=${defaultStore.areas_id}&` : query += ''
            defaultStore.cities_id > 0 ? query += `city=${defaultStore.cities_id }&` : query += ''
            
            setDefaultValue(
                {...defaultValue, 
                store:defaultStore})

            setStores(
                new Useable( fetchStores(query))
            )
        }else{}
    },[])

    const onSearch = (searchParames) => {

        setDefaultValue({...defaultValue, ...searchParames})

        let query = '';
        searchParames.area.id > 0 ? query += `area=${searchParames.area.id}&` : query += ''
        searchParames.city.id > 0 ? query += `city=${searchParames.city.id }&` : query += ''
        searchParames.keyword ? query += `keyword=${searchParames.keyword}&` : query += ''
        

        setStores(
            new Useable( fetchStores(query))
        )

    }

    const closeStoreSelect = () => {
        setStores(0)
    }

    const onNext = (store) => {
        if(store === undefined || !store){
            alert('ガス販売店を選択を選択してください。')
        }else{
            
            props.setStore(store)
            props.next()
        }
    }

    return (
        <div className="select">
        <FlowParts {...{flow:'flow2'}}></FlowParts>
        {stores === 0 &&
            
            <StoreSearchView {...{onSearch, defaultValue, prev:props.prev}}></StoreSearchView>
        }
        {
            stores !== 0 && 
            <Suspense fallback={<Loader></Loader>}>
                <StoreSelectView {...{
                    data:stores, 
                    closeStoreSelect, 
                    defaultValue, 
                    onNext}}></StoreSelectView>
            </Suspense> 
        }
        </div>

    )
}